import { Request } from './Request';

class SiteNotification {
	static applyClickers(notificationContainer) {
		if(SiteNotification.clickersApplied) {
			return;
		}
		notificationContainer.on('click', function(e) {
			$(this).removeClass('active');
			let data = {};
			data.read_notification_id = $(this).data('id');
			Request.apiv1('site/global_notifications', data);
		});

		SiteNotification.clickersApplied = true;
	}

	static setNotification(notification) {
		const notificationContainer = $('#site_notification');
		SiteNotification.applyClickers(notificationContainer);
		notificationContainer.addClass('active')
			.data('id', notification.id)
			.findCache('.content')
			.html(notification.content);
	}

	static removeNotification() {
		const notificationContainer = $('#site_notification');
		notificationContainer.removeClass('active');
	}


}

SiteNotification.clickersApplied = false;

export { SiteNotification };